import { isCurrencyCode } from '@nest-recruit/shared';

/**
 * The symbol a currency is written with inside a money box: "৳" for BDT, "$" for USD (06-qol §11:
 * currency always shows its symbol). `narrowSymbol` is what turns "BDT" into "৳"; a code `Intl`
 * has no symbol for comes back as the code itself.
 */
export function currencySymbol(code: string): string {
  if (!isCurrencyCode(code)) return code;
  const parts = new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).formatToParts(0);
  return parts.find((part) => part.type === 'currency')?.value ?? code;
}
